const KEY = 'instaport_booking_draft';
const MAX_AGE = 60 * 60 * 1000;

export const saveBookingDraft = (draft) => {
  sessionStorage.setItem(KEY, JSON.stringify({ ...draft, createdAt: Date.now() }));
};

export const readBookingDraft = () => {
  try {
    const draft = JSON.parse(sessionStorage.getItem(KEY));
    const validAddress = (address) => address && address.text &&
      Number.isFinite(Number(address.latitude)) && Number(address.latitude) !== 0 &&
      Number.isFinite(Number(address.longitude)) && Number(address.longitude) !== 0;
    if (draft && Date.now() - draft.createdAt < MAX_AGE &&
        validAddress(draft.pickup) && validAddress(draft.drop)) return draft;
  } catch (_) { /* Ignore invalid or unavailable draft. */ }
  return null;
};

export const clearBookingDraft = () => sessionStorage.removeItem(KEY);
